import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { TooltipProvider } from './components/ui/tooltip.tsx';
import { applyTheme, readTheme } from './lib/settings.ts';
import { createAppRouter } from './router.tsx';
import './styles/app.css';

applyTheme(readTheme());

async function boot() {
  if (import.meta.env.DEV && import.meta.env.VITE_API_MOCK === 'true') {
    // Dev only, loaded only when asked: the in-browser API (see src/dev/mock-api.ts).
    const { installMockApi } = await import('./dev/mock-api.ts');
    installMockApi();
  }
  const queryClient = new QueryClient({
    defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
  });
  const router = createAppRouter({ queryClient });
  const root = document.getElementById('root');
  if (!root) throw new Error('#root missing from index.html');
  createRoot(root).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider delayDuration={300}>
          <RouterProvider router={router} />
        </TooltipProvider>
      </QueryClientProvider>
    </StrictMode>,
  );
}

void boot();
